import { type ReactNode } from 'react'
import { type ElementFormatType } from 'lexical'
import { AlignCenter, AlignJustify, AlignLeft, AlignRight } from 'lucide-react'

export const FONT_FAMILY_OPTIONS = [
  { label: '系统字体', value: '' },
  { label: '宋体', value: 'SimSun' },
  { label: '微软雅黑', value: 'Microsoft YaHei' },
  { label: '黑体', value: 'SimHei' },
  { label: '楷体', value: 'KaiTi' },
  { label: 'Georgia', value: 'Georgia' },
  { label: '等宽字体', value: 'monospace' }
]

export const FONT_SIZE_OPTIONS = [
  { label: '12', value: '12px' },
  { label: '14', value: '14px' },
  { label: '16', value: '16px' },
  { label: '18', value: '18px' },
  { label: '20', value: '20px' },
  { label: '24', value: '24px' },
  { label: '28', value: '28px' },
  { label: '32', value: '32px' }
]

export const ALIGNMENT_OPTIONS: Array<{ icon: ReactNode; label: string; value: Exclude<ElementFormatType, ''> }> = [
  { icon: <AlignLeft aria-hidden size={14} />, label: '左对齐', value: 'left' },
  { icon: <AlignCenter aria-hidden size={14} />, label: '居中对齐', value: 'center' },
  { icon: <AlignRight aria-hidden size={14} />, label: '右对齐', value: 'right' },
  { icon: <AlignJustify aria-hidden size={14} />, label: '两端对齐', value: 'justify' }
]

export const TABLE_OPTIONS = [
  { key: '2x2', label: '2 × 2 表格', rows: '2', columns: '2' },
  { key: '3x3', label: '3 × 3 表格', rows: '3', columns: '3' },
  { key: '4x3', label: '4 × 3 表格', rows: '4', columns: '3' },
  { key: '5x4', label: '5 × 4 表格', rows: '5', columns: '4' }
]
